import gql from 'graphql-tag';

import multiUnitListWrapperFragments from '../MultiUnitListWrapper/MultiUnitListWrapper.fragments';

const multiUnitModalFragments = {
    Listing: gql`
        fragment MultiUnitModalListing on Listing {
            ...MultiUnitListWrapperListing
        }
        ${multiUnitListWrapperFragments.Listing}
    `
};

export default multiUnitModalFragments;
